<template>
    <div class="animated fadeIn">
        <div class="stripeBox stripeCenter">
            <div class="loaderWrap" role="status" aria-live="polite">
                <div v-if="isLoading" class="spinner" aria-hidden="true"></div>

                <div class="message">
                    <div v-if="isLoading" class="muted">
                        Verifying payment, please wait...
                    </div>
                    <div v-else-if="errorMessage" class="error">
                        <h1 class="error">ERROR</h1>
                        {{ errorMessage }}
                    </div>
                    <div v-else-if="success" class="success-container">
                        <div class="success-card">
                            <div class="success-icon">✓</div>

                            <h3 class="success-title">
                                Payment Verified Successfully
                            </h3>

                            <p class="success-message">
                                Your payment has been confirmed. You will be
                                redirected shortly.
                            </p>

                            <p class="success-subtext">
                                If you are not redirected automatically, click
                                the button below.
                            </p>

                            <button
                                class="btn btn-primary redirect-btn"
                                @click="redirectToPayment"
                            >
                                Go to Payment Page
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "PaymentVerify",
    data() {
        return {
            paymentId: this.$route.params.id,
            isLoading: true,
            errorMessage: "",
            success: false,
            redirectTimer: null,
        };
    },
    computed: {
        orderId() {
            try {
                const raw = sessionStorage.getItem(
                    `stripePaymentInitPayload_${this.paymentId}`,
                );
                if (raw) {
                    const payload = JSON.parse(raw);
                    return payload.providerPaymentId || "";
                }
            } catch (e) {
                // Ignore errors
            }
            return "";
        },
        redirectPath() {
            // const q = this.$route.query || {};
            // return (q.redirect || "/myaccount/Paymentinfo").toString();
        },
    },
    async mounted() {
        await this.verifyPayment();
    },
    beforeDestroy() {
        if (this.redirectTimer) {
            clearTimeout(this.redirectTimer);
            this.redirectTimer = null;
        }
    },
    methods: {
        clearInitPayload() {
            try {
                sessionStorage.removeItem(
                    `stripePaymentInitPayload_${this.paymentId}`,
                );
            } catch (e) {
                //
            }
        },
        getInitPayload() {
            try {
                const raw = sessionStorage.getItem(
                    `stripePaymentInitPayload_${this.paymentId}`,
                );
                return raw ? JSON.parse(raw) : null;
            } catch (e) {
                return null;
            }
        },
        getCurrentDate() {
            const now = new Date();
            const day = String(now.getDate()).padStart(2, "0");
            const month = String(now.getMonth() + 1).padStart(2, "0");
            const year = now.getFullYear();
            return `${day}/${month}/${year}`;
        },
        async verifyPayment() {
            this.isLoading = true;
            this.errorMessage = "";
            this.success = false;

            try {
                const orderId = this.orderId;
                if (!orderId) {
                    throw new Error(
                        "Payment Order Id not found. Please re-initiate the payment.",
                    );
                }

                const initPayload = this.getInitPayload() || {};

                // Map initPayload fields to verify API structure
                const payload = {
                    paymentOrderId: orderId,
                    tenant: initPayload.tenant || "",
                    user: initPayload.user?.id || initPayload.tenant || "",
                    plan: initPayload.planId || "",
                    amount: initPayload.amount || 0,
                    currency: initPayload.currency || "USD",
                    category: "BUSINESS",
                    // discount: q.discount ? Number(q.discount) : initPayload.discount || 0,
                    // discountType: q.discountType || initPayload.discountType || "PERCENTAGE",
                    activationDate: this.getCurrentDate(),
                    billingDetails: initPayload.billingDetails || {
                        company: "Acme Corp",
                        address: "123 Main St, Mumbai",
                        gstin: "27ABCDE1234F1Z5",
                    },
                };

                const res = await this.$store.dispatch(
                    "subscription/verifyStripePaymentAction",
                    payload,
                );

                if (!res || res.status !== 1) {
                    throw new Error(
                        (res && res.message) || "Verification failed.",
                    );
                }

                this.success = true;
                this.clearInitPayload();
                // this.redirectTimer = setTimeout(() => {
                //     this.$router.push(this.redirectPath);
                // }, 1500);
            } catch (e) {
                this.errorMessage = (e && e.message) || "Verification failed.";
            } finally {
                this.isLoading = false;
            }
        },
    },
};
</script>

<style>
.stripeBox {
    padding: 20px;
    border: 1px solid #e5e7eb;
    border-radius: 10px;
    background: #fff;
}

.stripeCenter {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 100vh;
}

.loaderWrap {
    text-align: center;
    width: 100%;
}

.spinner {
    width: 56px;
    height: 56px;
    margin: 0 auto 16px;
    border-radius: 50%;
    border: 6px solid rgba(0, 0, 0, 0.08);
    border-top-color: #3a49f9;
    animation: spin 1s linear infinite;
}
.success-container {
    display: flex;
    justify-content: center;
    align-items: center;
}

.success-card {
    background: #ffffff;
    padding: 40px;
    border-radius: 12px;
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.08);
    text-align: center;
    max-width: 420px;
    width: 100%;
}

.success-icon {
    font-size: 48px;
    color: #28a745;
    margin-bottom: 15px;
}

.success-title {
    font-weight: 600;
    margin-bottom: 15px;
}

.success-message {
    color: #555;
    margin-bottom: 10px;
}

.success-subtext {
    font-size: 14px;
    color: #888;
    margin-bottom: 25px;
}

.redirect-btn {
    padding: 8px 20px;
    border-radius: 8px;
}

@keyframes spin {
    to {
        transform: rotate(360deg);
    }
}

.message .muted {
    color: #374151;
    font-weight: 500;
}

.success {
    color: #16a34a;
    font-weight: 600;
}

.error {
    color: #dc2626;
    font-weight: 600;
}
</style>
